/* eslint-disable no-use-before-define */
import React from 'react'
import Ratings from './ratings'
import ActiveState from './active-state'

export default () => {

    return <React.Fragment>
    <div className="vertical-offset-xs"
        style={{
            backgroundColor:"#f6f6f6",
            padding:"10px"
        }}>

    <div className="row">
    <div className="col-md-12 col-xs-12">
        <div className="form-group col-md-5 col-lg-4" style={{marginBottom:0}}>
            <label
                htmlFor="municipals-scatter-graph-crriteria-rating"
            >Top Yielding Offerings by Credit Rating</label>
            <Ratings
                id="municipals-scatter-graph-crriteria-rating"
            />
        </div>
        <div className="col-md-4 col-lg-5">&nbsp;</div>
        <div className="form-group col-md-3 col-lg-3" style={{marginBottom:0}}>
            <label
                htmlFor="municipals-scatter-graph-crriteria-state"
            >Active State</label>
            <ActiveState
                id="municipals-scatter-graph-crriteria-state"
            />
        </div>
    </div></div>

    </div>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/municipals/scatter-graph/criteria/form.js